export default "__VITE_PUBLIC_ASSET__8d72a815__"